module.exports = __webpack_public_path__ + "static/media/Ban on services related to tourism.6651f4d3.png";